import React from 'react';
import { CheckInputProps } from '../CheckInput/CheckInput';
import { FieldWrapper, StyledCheckInput, LabelText } from './CheckField.styles';

export type CheckFieldProps = CheckInputProps & {
  label: string;
};

const CheckField = ({
  label,
  ...props
}: CheckFieldProps): React.ReactElement => (
  <FieldWrapper>
    <StyledCheckInput {...props} />
    <LabelText>{label}</LabelText>
  </FieldWrapper>
);

export default CheckField;
